// This file contains functionality used for the "special events" CMS page

export const specialEvent = {
    wrapper: $("#special-event"),
    event_name: 'ihreborn',
    init: () => {
        console.debug("special-event.js: init");
        specialEvent.injectHTML();
        $(document).on("submit", "#special-event-form", specialEvent.submitForm);
    },
    injectHTML: () => {
        const content = `
        <div class="form-section">
            <h2>Smygtitta på nyheter från Jonas Ihreborn</h2>
            <!--<h3>– En afton med goda utsikter</h3>-->
            <div class="adress">
                Mäster Samuelsgatan 65, Stockholm
                <br>
                <b>Tid och datum:</b> Tisdag 31/1, 18.00–21.00
                <br>
                <b>Sista anmälningsdag:</b> Onsdag 25/1
            </div>
            <form id="special-event-form">
                <div class="input-field-wrapper">
                    <label for='input-name'>Ditt namn</label>
                    <input id='input-name' name='input-name' type='text' minlength='2' required='required'>
                </div>
                <div class="input-field-wrapper">
                    <label for='input-email'>Din e-postadress</label>
                    <input id='input-email' name='input-email' type='email' minlength='3' required='required'>
                </div>

                <div class="input-field-wrapper">
                    <label for='input-name-guest'>Gästs namn</label>
                    <input id='input-name-guest' name='input-name-guest' minlength='2' type='text'>
                </div>
                <div class="input-field-wrapper">
                    <label for='input-email-guest'>Gästs e-postadress</label>
                    <input id='input-email-guest' name='input-email-guest' minlength='3'  type='email'>
                </div>

                <div class='input-honeypot' style='position: absolute; left: -9000px;'>
                    <input aria-hidden='true' id='input-honeypot' name='input-honeypot' placeholder='Only fill this in if you\'re a damn machine.' tabindex='-1' type='text'>
                </div>
                <input id='input-event-tag' type='hidden' value='${specialEvent.event_name}'>
                <input class='input-button' type='submit' value='Skicka anmälan'>
                <div class='form-message success' style='display:none;'>Vi har mottagit din anmälan.</div>
                <div class='form-message failure' style='display:none;'>Ett fel har uppstått! Var vänlig försök igen.</div>
            </form>
        </div>
        <div class="image-section">
            <img src="${prestashop.urls.img_url}special-event/event.png" alt="Inbjudan">
        </div>`;
        specialEvent.wrapper.html(content);
    },
    submitForm: (e) => {
        if ($("#input-honeypot").val()) {
            /*gtag('event', 'Submit', {
                'event_category': 'Forms',
                'event_label': 'Register for event spam',
            });*/
            return false;
        }
        
        const input = {
            name: $("#input-name").val(),
            email: $("#input-email").val(),
            event_name: specialEvent.event_name
        };
        if ($("#input-name-guest").val()) {
            input.name_guest = $("#input-name-guest").val();
            input.email_guest = $("#input-email-guest").val();
        }
        specialEvent.readFile(input);
        e.preventDefault();
    },
    readFile: (input) => {
        const filePath = prestashop.urls.base_url + 'misc/' + specialEvent.event_name + '.csv';
        console.log(filePath);
        const file = new XMLHttpRequest();
        file.open("GET", filePath, false);
        file.onreadystatechange = () => {
            if (file.readyState === 4 && (file.status === 200 || file.status == 0)) {
                //const fileContent = file.responseText;
                specialEvent.writeFile(/*fileContent, */input);
            }
            else {
                console.log("error reading file");
            }
        }
        file.send(null);
    },
    writeFile: (/*fileContent, */input) => {
        //input.tester = fileContent;
        $.ajax({
            type: "GET",
            url: "https://www.dpj.se/misc/special-event.php",
            data: input,
            dataType: "jsonp",  
            success: function(response) {
                if (response.status == 'Success') {
                    $('.form-message.success').fadeIn();
                    $("#special-event .input-button").fadeOut();
                }
                else {
                    $('.form-message.failure').fadeIn();
                }
            },
            error: function(response, msg) {
                $('.form-message.failure').fadeIn();
            }
        });  
        
    },
}

//<img class="info-image" src="${prestashop.urls.img_url}architect-bar/architect-bar-info.svg" alt="Arkitektbaren">s